'use client'

import { Link, useLocation } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from 'components/ui/breadcrumb'
import React from 'react'

const labelMap= {
  dashboard: 'Dashboard',
  awards: 'Awards',
  projects: 'Projects',
  workplans: 'Workplans',
  mel: 'MEL & Impact',
  indicators: 'Indicators',
  reports: 'Reports',
  compliance: 'Compliance',
  risks: 'Risks',
  issues: 'Issues',
  stakeholders: 'Stakeholders',
  partners: 'Partners',
  finance: 'Financial Monitor',
  evidence: 'Evidence',
  dashboards: 'Dashboards',
  delivery: 'Delivery',
  outputs: 'Outputs',
  admin: 'Administration',
  users: 'User Management',
  audit: 'Audit Logs',
  settings: 'Settings',
  profile: 'Profile',
}

export function Breadcrumbs() {
  const { pathname } = useLocation()
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length <= 1) {
    return (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-xs text-foreground">Dashboard</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    )
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {segments.map((segment, index) => {
          const href = '/' + segments.slice(0, index + 1).join('/')
          const isLast = index === segments.length - 1
          const label = labelMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1)

          return (
            <React.Fragment key={href}>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage className="text-xs text-foreground font-medium">
                    {label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={href} className="text-xs text-muted-foreground hover:text-foreground">
                      {label}
                    </Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator />}
            </React.Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}